import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import ContentsTypes from "@shared/enums/contentsTypes";
export const ColorImageBlock = {
    label: "Bloc decoration image",
    type: ContentsCustomTypes.COLOR_IMAGE_BLOCK,
    icon: "square",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Image",
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            label: "Couleur de fond",
            key: "backgroundColor",
            type: ContentsTypes.COLOR,
            value: "",
        },
        {
            label: "Icône",
            key: "icon",
            type: ContentsTypes.ICON,
        },
        {
            label: "Hauteur maximum du composant",
            key: "maxVerticalSize",
            type: ContentsTypes.INPUT_NUMBER,
            value: "",
        },
        {
            label: "Hauteur du block",
            key: "verticalSize",
            type: ContentsTypes.INPUT_NUMBER,
            value: "",
        },
        {
            label: "Largeur  du block",
            key: "horizontalSize",
            type: ContentsTypes.INPUT_NUMBER,
            value: "",
        },
    ],
};
